import { useSeo } from "@/hooks/useSeo";
import { Check } from "lucide-react";

const POINTS = [
  "Accurate parts made to drawing",
  "Clear, honest communication",
  "Careful setup and machining",
  "Practical solutions to real manufacturing problems",
];

export default function About() {
  useSeo(
    "About | Owner-Operated CNC Machine Shop | Edgeworks Manufacturing",
    "Edgeworks Manufacturing is a small, owner-operated CNC machining business in Eastern Ontario focused on accurate parts, clear communication, and practical solutions."
  );

  return (
    <div>
      <section className="border-b border-neutral-800 bg-neutral-900">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-orange-500">About</p>
          <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter text-white sm:text-5xl">
            A small machine shop that keeps it straightforward
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="space-y-5 text-neutral-300">
            <p className="text-lg leading-relaxed">
              Edgeworks Manufacturing is a small CNC machining business focused on accurate parts,
              clear communication, and practical solutions. The goal is to make it easy for local
              businesses to get prototypes, replacement parts, and small production runs made
              without unnecessary complication.
            </p>
            <p className="leading-relaxed text-neutral-400">
              It is owner-operated and intentionally kept small. That means you deal directly with
              the person setting up and running the work — no layers, no runaround. Jobs are quoted
              honestly from your drawing, model, or sample, and lead times are set based on what is
              actually achievable rather than what sounds good.
            </p>
            <p className="leading-relaxed text-neutral-400">
              The focus is on doing solid, dependable machining: reading the drawing carefully,
              setting up with attention to workholding and inspection, and helping customers solve
              real manufacturing problems — whether that is a one-off repair part or a small batch
              that needs to come out consistent.
            </p>
            <ul className="mt-6 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-center gap-3 text-neutral-200">
                  <Check className="shrink-0 text-orange-500" size={20} /> {p}
                </li>
              ))}
            </ul>
        </div>
      </section>
    </div>
  );
}
